import {getDefaultPath} from '../../library/helpers/url_sync';
import actions, {getView, getIsPC} from './actions';
import {isServer} from '../../library/helpers/isServer';

const preKeys = getDefaultPath();
const initState = {
    collapsed: false,
    view: !isServer && getView(window.innerWidth),
    height: !isServer && window.innerHeight,
    isPC: !isServer && getIsPC(window.innerWidth),
    openDrawer: false,
    openKeys: preKeys,
    current: preKeys,
    viewMode: 0, // 0: Facility View, 1: Admin View, 2: Portfolio View
};

export default function appReducer(state = initState, action) {
    switch (action.type) {
        case actions.COLLPSE_CHANGE:
            return {
                ...state,
                collapsed: !state.collapsed,
            };
        case actions.COLLPSE_OPEN_DRAWER:
            return {
                ...state,
                openDrawer: !state.openDrawer,
            };
        case actions.TOGGLE_ALL:
            if (state.view !== action.view || action.height !== state.height || state.isPC !== action.isPC) {
                const height = action.height ? action.height : state.height;
                return {
                    ...state,
                    collapsed: action.collapsed,
                    view: action.view,
                    height,
                    isPC: action.isPC,
                };
            }
            break;
        case actions.CHANGE_OPEN_KEYS:
            return {
                ...state,
                openKeys: action.openKeys,
            };
        case actions.CHANGE_CURRENT:
            return {
                ...state,
                current: action.current,
            };
        case actions.CLEAR_MENU:
            return {
                ...state,
                openKeys: [],
                current: [],
            };
        case actions.SET_VIEW_MODE:
            return {
                ...state,
                viewMode: action.viewMode,
            };
        default:
            return state;
    }
    return state;
}
